import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  padding: 0px 70px;\n  @media (max-width: ", "px) {\n    padding: 0px;\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  background: none;\n  border: none;\n  cursor: ", ";\n  font-size: 18px;\n  line-height: 26px;\n  margin-right: 8px;\n  outline: none;\n  position: relative;\n  :first-of-type {\n    padding-left: 0px;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  white-space: nowrap;\n  background: #fff;\n  height: 67px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  margin-bottom: 53px;\n  width: 100%;\n  height: 100%;\n  line-height: 30px;\n  border-bottom: ", ";\n  color: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React, { useState } from 'react';
import styled from '../utils/styling/styled-components';
import { Heading } from '../Typography';
var StyledHeading = styled(Heading)(_templateObject(), function (props) {
  return props.activeTab ? "".concat(props.theme.colors.slate, " solid 2px") : '';
}, function (props) {
  return props.activeTab ? props.theme.colors.slate : props.theme.colors.stone;
});
var TabContainer = styled.div(_templateObject2());
var Tab = styled.button(_templateObject3(), function (props) {
  return props.activeTab ? 'initial' : 'pointer';
});
var TabsContainer = styled.div(_templateObject4(), function (props) {
  return props.theme.breakpoints.sm;
});

var Tabs = function Tabs(_ref) {
  var className = _ref.className,
      handleClick = _ref.handleClick,
      options = _ref.options,
      testId = _ref.testId;

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      activeTabIndex = _useState2[0],
      setActiveTabIndex = _useState2[1];

  var handleTabClick = function handleTabClick(e, index) {
    if (index !== activeTabIndex) setActiveTabIndex(index);
    if (handleClick) handleClick(e);
  };

  return /*#__PURE__*/React.createElement(TabsContainer, {
    className: className,
    "data-testid": testId
  }, /*#__PURE__*/React.createElement(TabContainer, null, options === null || options === void 0 ? void 0 : options.map(function (option, index) {
    return /*#__PURE__*/React.createElement(Tab, {
      "data-testid": "".concat(testId && "".concat(testId, "_"), "TAB_").concat(index),
      id: option.id,
      key: index,
      onClick: function onClick(e) {
        return handleTabClick(e, index);
      },
      activeTab: activeTabIndex === index
    }, /*#__PURE__*/React.createElement(StyledHeading, {
      activeTab: activeTabIndex === index
    }, option.label));
  })), /*#__PURE__*/React.createElement("div", null, options[activeTabIndex].content));
};

export { Tabs };